import {
  type EstimateIntercityOrderResponse,
  type EstimateIntercityOrderRequestBody,
  type DefaultQueryError,
  estimateIntercityOrderFn,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useEstimateIntercityOrder = (
  opts?: UseMutationOptions<
    EstimateIntercityOrderResponse[],
    DefaultQueryError,
    EstimateIntercityOrderRequestBody
  >
) =>
  useMutation<
    EstimateIntercityOrderResponse[],
    DefaultQueryError,
    EstimateIntercityOrderRequestBody
  >({
    mutationKey: ['estimateIntercityOrderFn'],
    mutationFn: estimateIntercityOrderFn,
    ...opts,
  });
